<template>
  <div class="copy-right">
    <!-- <p>版权所有◎2011应急管理部消防救援局</p> -->
    <p>主办：浙江省消防救援总队 </p>
    <!-- <p>ICP备案编号：京ICP备05063117网站标识码：bm09000004</p> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },

  created() {},

  methods: {
  }
}
</script>

<style lang='scss' scoped>
.copy-right {
  font-size: $fs-small-l;
  color: $color-LightGrey;
  font-weight: 400;
  p {
    margin-top: 8px;
  }
}
</style>